/// <reference path="../interfaces/lightsliderconfig.ts" />
module Tapas.ViewModels {
    export class FrontpageViewModel extends Ftw.ViewModels.BaseViewModel {
        public lightSliderConfig: LightSliderConfig;
        public username: KnockoutObservable<string>;
        public password: KnockoutObservable<string>;

        constructor() {
            super();       

            this.lightSliderConfig = {
                item: 1,
                auto: true,
                loop: true,
                slideMargin: 0,
                speed: 700,
                pause: 7000,
                pauseOnHover: true,
                pager: true,
                enableDrag: false,
                controls: false
            };
        }
    }
}